export default __webpack_public_path__ + "static/media/cp_BannerAgotados.2d5fca4b.jpg";